import { format } from 'date-fns';

const NBSP = String.fromCharCode(160);
const DBNBSP = String.fromCharCode(160, 160);

function applyMonthAbbreviations(str) {
    return str
        .replace('Jun', 'June')
        .replace('Jul', 'July')
        .replace('Sep', 'Sept');
}

function formatTime(date) {
    return date.getMinutes()
        ? format(date, 'h:mmaa')
        : format(date, 'haa');
}

export default function formatDateRange(startDate, endDate = null, options = {}) {
    const { hideTime = false } = options;

    if (!endDate) {
        const day = format(startDate, 'EEE');
        const month = applyMonthAbbreviations(format(startDate, 'MMM'));
        const dom = format(startDate, 'd');
        const year = format(startDate, 'yyyy');

        if (hideTime) {
            return day + DBNBSP + month + NBSP + dom + ',' + NBSP + year;
        }

        return day + DBNBSP + month + NBSP + dom + ',' + NBSP + year + DBNBSP + formatTime(startDate);
    }

    const startMonth = applyMonthAbbreviations(format(startDate, 'MMM'));
    const endMonth = applyMonthAbbreviations(format(endDate, 'MMM'));
    const startDay = format(startDate, 'd');
    const endDay = format(endDate, 'd');
    const startYear = format(startDate, 'yyyy');
    const endYear = format(endDate, 'yyyy');

    if (format(startDate, 'yyyyMMdd') === format(endDate, 'yyyyMMdd')) {
        const dayOfWeek = format(startDate, 'EEE');

        if (hideTime) {
            return startMonth + NBSP + startDay + ',' + NBSP + startYear;
        }

        const startTime = formatTime(startDate);
        const endTime = formatTime(endDate);

        if (startTime === endTime) {
            return startMonth + NBSP + startDay + ',' + NBSP + startYear + DBNBSP + startTime;
        }

        return startMonth + NBSP + startDay + ',' + NBSP + startYear + DBNBSP + startTime + NBSP + '-' + NBSP + endTime;
    }

    if (startYear !== endYear) {
        return startMonth + NBSP + startDay + ',' + NBSP + startYear + NBSP + '&' + NBSP + endMonth + NBSP + endDay + ',' + NBSP + endYear;
    }

    if (format(startDate, 'yyyyMM') === format(endDate, 'yyyyMM')) {
        return startMonth + NBSP + startDay + '–' + endDay + ',' + NBSP + startYear;
    }

    return startMonth + NBSP + startDay + '–' + endMonth + NBSP + endDay + ',' + NBSP + startYear;
}
